import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { AuthService } from "src/app/core/services/auth.service";
import { StorageService } from "src/app/core/services/storage.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public formLogin: FormGroup;
  public showPassword: boolean;
  public loader = {
    login: false,
  };
  error: any;

  googleCaptchaSiteKey = environment.googleCaptchaSiteKey;
  googleCaptchaResponse: string;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService,
    private gaService: GoogleAnalyticsService
  ) {
    this.formLogin = this.fb.group({
      companyRut: [
        undefined,
        [
          Validators.required,
          Validators.pattern(
            /^(\d{6,9}\-(\d|k))$|^(\d{0,3}\.{0,1}\d{3}\.\d{3}\-(\d|k))$|^(\d{6,9})(\d|k)$/i
          ),
        ],
      ],
      userRut: [
        undefined,
        [
          Validators.required,
          Validators.pattern(
            /^(\d{6,9}\-(\d|k))$|^(\d{0,3}\.{0,1}\d{3}\.\d{3}\-(\d|k))$|^(\d{6,9})(\d|k)$/i
          ),
        ],
      ],
      password: [undefined, [Validators.required]],
      rememberMe: [undefined],
      recaptchaReactive: ['', [Validators.required]]
    });
    this.showPassword = false;
    this.error = {
      status: false,
      descripcion: "",
    };
    this.loader = {
      login: false,
    };
  }

  ngOnInit(): void {
    const storageLogin = this.storageService.getLocalStorage("cookie_login");
    const usuario = localStorage.getItem("usuario");
    if (usuario) {
      localStorage.removeItem("usuario");
    }
    localStorage.clear();
    if (storageLogin) {
      console.log(
        "🚀 ~ file: login.component.ts ~ line 41 ~ LoginComponent ~ ngOnInit ~ storageLogin",
        storageLogin
      );
      this.login(storageLogin);
    } else {
      this.storageService.removeLocalStorage("cookie_login");
    }
  }

  public get f() {
    return this.formLogin.controls;
  }



  public showPasswordHandle(): void {
    this.showPassword = !this.showPassword;
  }

  public forgot(): void {
    this.router.navigate(["auth/recover"]);
  }


  resolved(event) {
    this.googleCaptchaResponse = event;
    //console.log("RESPUESTA RECAPTCHA: ", event);
  }

  public async login(form = this.formLogin.value): Promise<void> {
    try {
      this.loader.login = true;
      const body = {
        rutEmpresa: form.companyRut.replace(/(\.)?\-?/g, ""),
        rutCliente: form.userRut.replace(/(\.)?\-?/g, ""),
        password: form.password,
        RecaptchaResponse:this.googleCaptchaResponse
      };
      const response = await this.authService.login(body);
      if (form.rememberMe) {
        this.storageService.setLocalStorage("cookie_login", form);
      }
      if (response.error.codError === 0) {
        this.loader.login = false;
        let tipo = JSON.parse(localStorage.getItem("usuario")).usuario.tipo;
        if (response.usuario.cambiaClave) {
          this.router.navigate(["/auth/change"]);
        } else {
          if (tipo == "ENEX") {
            this.router.navigate(["ejecutivo"]);
          } else {
            this.router.navigate(["main"]);
          }
        }
      } else {
        this.formLogin.controls["recaptchaReactive"].setValue("");
        console.log("fallo el inicio sesion");
        this.error.status = true;
        this.error.descripcion = "Rut o contraseña incorrecto";
        this.loader.login = false;
      }
    } catch (error) {
      this.formLogin.controls["recaptchaReactive"].setValue("");

      this.loader.login = false;
      console.log("Error en login!", error);

      this.error.status = true;
      if (error.error != null && error.error.error.codError === 17) {
        this.error.descripcion = error.error.error.desError;
      }
      else if (error.error != null && error.error.error.codError === 5) {
        this.error.descripcion = error.error.error.desError;
      }
      else {
        this.error.descripcion = "Rut o contraseña incorrecto";
      }
    }
  }

  public goToSignUp(): void {
    this.gaService.event('Registro', 'Registro', 'Acceso');
    this.gaService.pageView('/Registro');
    this.router.navigate(["auth/sign-up"]);
  }

  public goToRegisterExpressRetail(): void {
    this.gaService.event('Registro', 'Registro', 'Acceso');
    this.gaService.pageView('/Registro');
    this.router.navigate(['auth/register-express']);
  }
}
